import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobDisabledModule, MobTeamsShare } from '../../lib';

function RouteMobteamsShare(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_o5d7wi`} path={`${parentPath}/mobile/uk/teamsShare`}>
      {
        window.TEAMS?.isDisabledModule?.("teamSharing") ?
        <MobDisabledModule weId={`${props.weId || ''}_kj0za7`} /> :
        // <MobTeamsShare weId={`${props.weId || ''}_4ln3jy`} isPortalElement={true} pageSize={5}/>
        <MobTeamsShare weId={`${props.weId || ''}_4ln3jy`} showTitle={true}/>
      }
    </Route>
  )
}

export default withRouter(RouteMobteamsShare);